import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class SavedPointsGraph extends AbstractScatterVisualization {
}
